import { StringLike } from "@firebase/util"

export class DropdownHelperModel {
    id: string;
    name: string
}